import {css} from 'lit';

export const cssProperties = css`
  :host {

	--font-big-title: 300 72px "Lineto Brown Pro Light", sans-serif;
	--font-small-title: 300 51px "Lineto Brown Pro Light", sans-serif;
	--font-modal-title: 300 27px "Lineto Brown Pro Light", sans-serif;
	--font-modal-title-bold: 400 27px "Lineto Brown Pro Bold", sans-serif;
	--font-modal-title-regular: 400 27px "Lineto Brown Pro Regular", sans-serif;
	--font-info-light: 300 19px "Lineto Brown Pro Light", sans-serif;
	--font-light: 300 14px "Lineto Brown Pro Light", sans-serif;
	--font-bold: 700 14px "Lineto Brown Pro Bold", sans-serif;
	--font-summary-paragraph: 300 15px "Lineto Brown Pro Light", sans-serif;
	--font-summary-table: 300 13px "Lineto Brown Pro Light", sans-serif;
	--font-mobile-title: 300 35px "Lineto Brown Pro Light", sans-serif;


	--color-black: #000;
	--color-white: #fff;
	--color-grey1: #ececec;
	--color-grey2: #e6e6e6;
	--color-grey3: #c6c6c6;
	--color-grey4: #939393;
	--color-grey5: #606060;
	--color-grey6: #313131;
	--color-grey7: #191919;

	--color-focus: #3E3EFF;
	--color-warn: #C00000;
	--color-ok: #247500;

	--font-family-light: "Lineto Brown Pro Light";
	--font-family-bold: "Lineto Brown Pro Bold";
	--font-family-regular: "Lineto Brown Pro Regular";
	--font-family-monospace: "BrownMonoLLWeb-Regular", monospace;

	--widget-max-width: 320px;
	--padding: 18px;
	--very-small-padding: 12px;
	--small-padding: 16px;
	--large-padding: 32px;
	--very-large-padding: 62px;
	--table-padding: 8px;

	--very-small-space: -32px;
	--medium-space: 14px;
	--large-space: 24px;

	--color-background-widget: rgba(0,0,0,0.4);
	--color-background-widget-active: #ffffff;
	--color-text-widget: #939393;
	--color-text-widget-active: #000;
	--border-widget: 1px solid #ffffff;
	--border-widget-active: 1px solid #ffffff;
	--border-radius-widget: 2px;
	--border-widget-fixed: 1px solid #939393;

	--border-desired: 1px dotted #2fa101;
	--border-conflict: 1px dotted #ff0000;

	--arrows-width: 8px;
	--arrows-gap: 10px;

	--height-title: 32px;
	--height-widget: 36px;
	--font-size-widget: 15px;
	--font-size-widget-small: 13px;
	--font-size-widget-small-mono: 12px;

	--font-size-sections: 15px;
	--color-text-sections: #808080;
	--color-text-sections-active: #ffffff;
	--border-color-sections: #414141;
	--border-color-sections-satisfied: #949494;
	--border-color-sections-active: #d8d8d8;

	--sections-gap: 9px;
	--sections-minwidth: 200px;
	--sections-progress-height: 48px;

	--tab-columns-small-width: 327px;
	--tab-columns-very-small-width: 288px;
	--column-gap: 20px;
	--column-min-width: 212px;


	--specsheet-minwidth: 230px;
	--specsheet-maxwidth: 1200px;

	--specsheet-border: 0.25pt solid #a8a8a9;
	--specsheet-feature-padding: 3px;
	--specsheet-featuregroup-gap: 25px;

	--specsheet-large-gap: 80px;
	--specsheet-medium-gap: 40px;
	--specsheet-small-gap: 20px;

	--specsheet-print-large-gap: 8mm;
	--specsheet-print-medium-gap: 4mm;
	--specsheet-print-small-gap: 2mm;
	--specsheet-print-feature-padding: 1.15mm;

	--font-specsheet-title: 700 27px "Lineto Brown Pro Light", sans-serif;
	--font-specsheet-bold: 700 15px "Lineto Brown Pro Bold", sans-serif;
	--font-specsheet-light: 300 15px "Lineto Brown Pro Light", sans-serif;
	--font-specsheet-sectiontitle: 300 16px "Lineto Brown Pro Light", sans-serif;
	--font-specsheet-small-bold: 700 10px "Lineto Brown Pro Bold", sans-serif;
	--font-specsheet-small-light: 300 10px "Lineto Brown Pro Light", sans-serif;

	--font-specsheet-print-title: 700 20px "Lineto Brown Pro Light", sans-serif;
	--font-specsheet-print-title-bold: 400 20pt "Lineto Brown Pro Regular", sans-serif;
	--font-specsheet-print-bold: 400 10px "Lineto Brown Pro Regular", sans-serif;
	--font-specsheet-print-light: 300 10px "Lineto Brown Pro Light", sans-serif;
	--font-specsheet-print-sectiontitle: 300 11pt "Lineto Brown Pro Light", sans-serif;
	--font-specsheet-print-small-bold: 400 7pt "Lineto Brown Pro Regular", sans-serif;
	--font-specsheet-print-small-light: 300 7pt "Lineto Brown Pro Light", sans-serif;

	--font-specsheet-headline: 300 24px "Lineto Brown Pro Light", sans-serif;
	--font-specsheet-print-headline: 300 18px "Lineto Brown Pro Light", sans-serif;
	--font-specsheet-small-text: 300 15px "Lineto Brown Pro Light", sans-serif;
	--font-specsheet-print-small-text: 300 8px "Lineto Brown Pro Light", sans-serif;


	--vertical-slider-number-element-height: 12px;
	--vertical-slider-major-numbers-left-indicator: 15px;
	--vertical-slider-major-numbers-left-padding: 17px;
	--vertical-slider-numbers-list-padding: 6px;
	--vertical-slider-min-height: 80px;
	--vertical-slider-width: 82px;
	--vertical-slider-arrow-width: 65px;
  }
`;

